/**
 * One string for the `onSubmit` guard, the live validation rule and the tests,
 * so the field-level and summary-panel wordings cannot drift apart.
 *
 * Lives here rather than in `useCreateTradeForm` on purpose: the validation
 * effect needs it too, and importing a *value* back from `useCreateTradeForm`
 * turned that file's type-only back-edge into a real ESM cycle.
 */
export const CUSTODIAN_ACCOUNT_UNRESOLVED_MESSAGE =
  'Select a custodian with an account number — no custodian account is configured';
